import React, {FC, useState} from 'react'
import HistoryDialog from './HistoryDialog'
import StatusHistoryChangeDialog from './StatusHistoryDialog'

interface Props {
  currentOperation: any
  summary: any
  title: string
  refundItems: any[]
  newItems: any[]
  updatedItems: any[]
  orderStatusSummary: any
  orderEditId?: string
}

export const OrderDetailHistory: FC<Props> = (props) => {
  const [showDialog, setShowDialog] = useState(false)

  const handleOpen = () => {
    setShowDialog(true)
  }

  const handleClose = () => {
    setShowDialog(false)
  }

  if (props.orderStatusSummary && !props.orderEditId) {
    return (
      <div className='d-flex justify-content-start mb-2'>
        <button
          className='bg-transparent border-0 underline text-gray-600 fw-bold p-0 strike'
          onClick={handleOpen}
        >
          <ins> View Detail History</ins>
        </button>
        {showDialog && <StatusHistoryChangeDialog onClose={handleClose} {...props} />}
      </div>
    )
  }

  if (props.summary) {
    return (
      <div className='d-flex justify-content-start mb-2'>
        <button
          className='bg-transparent border-0 underline text-gray-600 fw-bold p-0 strike'
          onClick={handleOpen}
        >
          <ins> View Detail History</ins>
        </button>
        <HistoryDialog onClose={handleClose} show={showDialog} {...props} />
      </div>
    )
  }
  return null
}

export default OrderDetailHistory
